import { render, staticRenderFns } from "./Reminders.vue?vue&type=template&id=62c469be&"
import script from "./Reminders.vue?vue&type=script&lang=ts&"
export * from "./Reminders.vue?vue&type=script&lang=ts&"
import style0 from "./Reminders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports